import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void): () => void {
	window.addEventListener("online", onChange);
	window.addEventListener("offline", onChange);
	return () => {
		window.removeEventListener("online", onChange);
		window.removeEventListener("offline", onChange);
	};
}

/**
 * Есть ли у браузера сеть.
 *
 * `useSyncExternalStore`, а не `useEffect` + `useState`: снапшот читается
 * синхронно при первом рендере, поэтому экран, открытый уже без сети, сразу
 * показывает предупреждение, а не мигает работоспособной формой.
 *
 * Третий аргумент — серверный снапшот: без него тест в happy-dom падает на
 * гидрации.
 *
 * `navigator.onLine` знает только про физическое подключение — этого хватает,
 * чтобы не отправлять запрос заведомо в пустоту, но обработку ошибок мутаций
 * он не заменяет.
 *
 * Живёт в ките: копии были в `sso-web` (форма входа) и в `id-web` (три раздела
 * аккаунта), обе с комментарием «до появления общего дома». Дом — здесь.
 */
export function useOnline(): boolean {
	return useSyncExternalStore(
		subscribe,
		() => navigator.onLine,
		() => true,
	);
}
